module.exports = __webpack_public_path__ + "img/sigla.0032386a.svg";